import { useContext } from 'react';
import Url from 'lib/siteurls';
import type { CmsObject } from 'entities/cms';
import { ProductsContext } from 'context-providers/products-provider';
import { CartContext } from 'context-providers/cart-provider';
import { useWaitlistButtonText } from 'hooks/use-waitlist-button-text';

export const usePdpStickyBar = (
  selectedSku: string,
  siteBuy?: CmsObject | null,
  outOfStock = false,
) => {
  const { getProduct } = useContext(ProductsContext);
  const { openCart } = useContext(CartContext);
  const product = getProduct(selectedSku);
  const waitlistButtonText = useWaitlistButtonText(outOfStock);

  const content = siteBuy?.fields;
  const text = content?.heading || product?.name || '';
  const ctaLabel = outOfStock
    ? waitlistButtonText
    : (product?.availability === 'UNAVAILABLE' && 'Preorder Now') ||
      content?.button?.[0] ||
      'Start Now';
  const href = product?.code ? `/cart?cart=${product.code}` : Url.buy;

  const onCtaClick =
    outOfStock || !product?.code
      ? undefined
      : () => openCart({ skus: [product.code] });

  return {
    text,
    href: outOfStock ? undefined : href,
    onCtaClick,
    ctaLabel,
    ctaDisabled: outOfStock && waitlistButtonText === 'Waitlist Joined',
  };
};
